export const LANGUAGE_STORAGE_KEY = 'cashless_language';
export const DEFAULT_LANGUAGE = 'en';

export const SUPPORTED_LANGUAGES = ['en', 'ar', 'fr'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const RTL_LANGUAGES: AppLanguage[] = ['ar'];

export const isSupportedLanguage = (value: string | null | undefined): value is AppLanguage => {
  return !!value && SUPPORTED_LANGUAGES.includes(value as AppLanguage);
};

export const sanitizeLanguage = (value: string | null | undefined): AppLanguage => {
  if (isSupportedLanguage(value)) return value;
  return DEFAULT_LANGUAGE;
};

export const detectInitialLanguage = (): AppLanguage => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;

  const savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (isSupportedLanguage(savedLanguage)) return savedLanguage;

  const browserLanguage = window.navigator.language?.split('-')[0]?.toLowerCase();
  if (isSupportedLanguage(browserLanguage)) return browserLanguage;

  return DEFAULT_LANGUAGE;
};

export const getLanguageDirection = (language: string): 'rtl' | 'ltr' => {
  return RTL_LANGUAGES.includes(sanitizeLanguage(language)) ? 'rtl' : 'ltr';
};

